import contentJson from 'views/EMR/components/PCC/Walkthrough/content.json';
import type {
  AgreementPageDefinition,
  ConfigurePageDefinition,
  ContentPageDefinition,
  NavigationPageId,
  OverviewPageDefinition,
  SuccessPageDefinition,
  WalkthroughContent,
  WalkthroughPageDefinition,
  WalkthroughPageId,
} from 'views/EMR/components/PCC/Walkthrough/types';

export const walkthroughContent = contentJson as WalkthroughContent;

export const NAVIGATION_PAGE_IDS: NavigationPageId[] = [
  'overview',
  'programs',
  'how-it-works',
  'pricing',
  'good-to-know',
  'activate',
  'configure',
];

export function getPageById(
  pageId: WalkthroughPageId,
): WalkthroughPageDefinition {
  const page = walkthroughContent.pages.find(
    (candidate) => candidate.id === pageId,
  );

  if (!page) {
    throw new Error(`Unknown PCC walkthrough page: ${pageId}`);
  }

  return page;
}

export function getOverviewPage(): OverviewPageDefinition {
  return getPageById('overview') as OverviewPageDefinition;
}

export function getSuccessPage(
  pageId: 'activated' | 'pending' = 'activated',
): SuccessPageDefinition {
  return getPageById(pageId) as SuccessPageDefinition;
}

export function getContentPage(
  pageId: Exclude<NavigationPageId, 'overview' | 'configure'>,
): ContentPageDefinition {
  return getPageById(pageId) as ContentPageDefinition;
}

export function getAgreementPage(): AgreementPageDefinition {
  return getPageById('activate') as AgreementPageDefinition;
}

export function getConfigurePage(): ConfigurePageDefinition {
  return getPageById('configure') as ConfigurePageDefinition;
}

export function formatTemplate(
  template: string,
  values: Record<string, string | number>,
): string {
  return Object.entries(values).reduce(
    (result, [key, value]) => result.replace(`{${key}}`, String(value)),
    template,
  );
}
